
$(document).ready(function () {
    $('#collection-search').on('submit', function (e) {
        e.preventDefault();
        var _this = $(this),
            formData = new FormData(this),
            listController = $('.productgrid--utils, .pagination--container'),
            productList = $('.productgrid--items'),
            collection = formData.get('collection'),
            raw = (formData.get('q') || '').trim(),
            isNumeric = /^\d+$/.test(raw),
            q,
            query;

        if (raw.length === 0) {
            window.location.reload(true);
            return;
        }
        if (isNumeric) {
            // Part number / SKU: exact match only, no wildcard
            q = raw;
            query = 'variants.sku:' + q + ' OR ' + q + ' ' + collection;
        } else {
            q = raw.split(/\s+/).join('*');
            query = 'variants.sku:' + q + ' OR ' + q + '* ' + collection;
        }

        $.ajax({
            url: _this.attr('action'),
            data: {
                type: 'product',
                view: 'json',
                q: query
            },
            dataType: 'html',
            success: function (data) {
                listController.hide();
                productList.html(data).trigger('theme:rimg:watch');
            }
        });
    });
});